import React, { useState, useRef, useEffect } from 'react';
import { Download } from 'lucide-react';
import { Button } from './button';
import { exportToExcel, exportToCSV } from '../../lib/exportData';

/**
 * Dropdown button that exports data to Excel or CSV.
 * @param {{ rows: Array<Object>, filename?: string, disabled?: boolean }} props
 */
export default function ExportButton({ rows, filename = 'export', disabled = false }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  if (!rows || rows.length === 0) return null;

  return (
    <div className="relative inline-block" ref={ref}>
      <Button
        size="sm"
        variant="outline"
        className="h-7 gap-1 text-xs"
        disabled={disabled}
        onClick={() => setOpen(!open)}
      >
        <Download className="w-3.5 h-3.5" /> Export
      </Button>
      {open && (
        <div className="absolute right-0 mt-1 w-36 bg-popover border border-border rounded-md shadow-lg z-50">
          <button
            className="w-full text-left px-3 py-2 text-xs hover:bg-muted/50"
            onClick={() => { exportToExcel(rows, filename); setOpen(false); }}
          >
            Export as Excel
          </button>
          <button
            className="w-full text-left px-3 py-2 text-xs hover:bg-muted/50"
            onClick={() => { exportToCSV(rows, filename); setOpen(false); }}
          >
            Export as CSV
          </button>
        </div>
      )}
    </div>
  );
}
